import { DOCUMENT } from '@angular/common';
import { Directive, ElementRef, HostListener, Input, inject } from '@angular/core';

@Directive({
    selector: '[bsLinearStakeScroll]',
    standalone: false,
})
export class LinearStakeScrollDirective {
    private readonly _doc = inject(DOCUMENT);

    constructor(private element: ElementRef) {}

    @Input('bsLinearStakeScroll') parentSelector = '';

    @HostListener('mouseup') onClick() {
        const element = this.element.nativeElement as HTMLElement;
        const scrollContainer = this._doc.querySelector(this.parentSelector);

        if (!element || !scrollContainer) return;

        const MARGIN = 12;

        setTimeout(() => {
            const elementRect = element.getBoundingClientRect();
            const containerRect = scrollContainer.getBoundingClientRect();

            const top = elementRect.top - containerRect.top;
            const outOfBoundTop = top < 0;
            const outOfBoundBottom = top + elementRect.height > containerRect.height;

            if (outOfBoundTop) {
                scrollContainer.scrollBy({
                    behavior: 'smooth',
                    top: top - MARGIN,
                });
            } else if (outOfBoundBottom) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'end',
                });
            }
        }, 200);
    }
}
